export default "__VITE_ASSET__C36Z2mup__"